import PlatformWrapper from './PlatformWrapper';

export default PlatformWrapper;
